import { Container, Typography } from '@cleartrip/ct-design-components'

import { useEliteUnlockSoonBenefits } from './useEliteUnlockSoonContent'

const EliteBenefitsGrid = () => {
    const benefits = useEliteUnlockSoonBenefits()

    return (
        <Container className="flex flex-wrap flex-center flex-gap-3" style={{ width: '300px' }}>
            {benefits.map((benefit, index) => (
                <Container
                    key={index}
                    backgroundColor="rgba(255, 255, 255, 0.5)"
                    className="flex flex-middle flex-center br-16 px-3"
                    style={{ width: '144px', height: '68px' }}
                >
                    <Typography className="ta-center" variant="HM3">
                        {benefit}
                    </Typography>
                </Container>
            ))}
        </Container>
    )
}

export default EliteBenefitsGrid
